import React from "react";
import Blog from "../components/HomePage/Blog/Blog";
import MobileHeader from "../mobileComponent/MobileEndpoints/MobileHeader";
import MobilePopularSearch from "../mobileComponent/MobileEndpoints/MobilePopularSearch";
import MobileFooter from "../mobileComponent/MobileEndpoints/MobileFooter";
import BottomPromises from "../components/HomePage/BottomPromises";
import PopularSearch from "../components/HomePage/PopularSearch";
import Footer from "../components/HomePage/Footer";
import ScrollPromices from "../components/HomePage/ScrollPromices";
import Header from "../components/HomePage/Header";
import { useMediaQuery } from "react-responsive";
import styled from "styled-components";

const BlogPage = () => {
  const isDesktopOrLaptop = useMediaQuery({
    query: "(min-width: 501px)",
  });
  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 500px)" });

  return (
    <>
      {isDesktopOrLaptop && (
        <>
          <HeaderDiv>
            <ScrollPromices />
            <Header />
          </HeaderDiv>
          <Blog />
          <BottomPromises />
          <PopularSearch />
          <Footer />
        </>
      )}
      {isTabletOrMobile && (
        <>
          <MobileHeaderDiv>
            <MobileHeader />
          </MobileHeaderDiv>
          <Blog />
          <MobilePopularSearch />
          <MobileFooter />
        </>
      )}
    </>
  );
};

export default BlogPage;

const HeaderDiv = styled.div`
  width: 100%;
  height: auto;
  position: sticky;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
`;

const MobileHeaderDiv = styled.div`
  width: 100%;
  height: auto;
  position: sticky;
  top: 0;
  left: 0;
  right: 0;
  z-index: 999;
`;
